export default __webpack_public_path__ + "static/media/everyoneclose.52bf8b3c.mp3";